import axios from 'axios';
import andromedaAPI from '../../utils/andromeda-api';

const heliosEndpoint = process.env.REACT_APP_EC2API;

export const makeAMSSyncRequest = async apiPath => {
  try {
    const { data } = await axios.get(`${heliosEndpoint}/${apiPath}`);
    return { success: true, message: data };
  } catch ({ response }) {
    console.error(
      `Error making AMS Sync request for ${apiPath}`,
      response.data
    );
    return { success: false, message: response.data };
  }
};

export const makeLegacyAMSSyncRequest = async (apiPath, body) => {
  try {
    const { data } = await axios.post(`${heliosEndpoint}/${apiPath}`, body);
    return data;
  } catch (e) {
    return console.error(`Error making AMS Sync request for ${apiPath}`, e);
  }
};

export const makeRapGZAMSSyncRequest = async (apiPath, body) => {
  try {
    const { data } = await axios.post(`${heliosEndpoint}/${apiPath}`, body);
    return { success: true, message: data };
  } catch ({ response }) {
    console.error(
      `Error making AMS Sync request for ${apiPath}`,
      response.data
    );
    return { success: false, message: response.data };
  }
};

export const fetchRAMCOLists = async (orgId, filter) => {
  try {
    const { data } = await andromedaAPI.get('ams/', {
      params: {
        orgId,
        filter,
      },
    });
    return { success: true, lists: data.result };
  } catch ({ response }) {
    console.error('Error retrieving RAMCO lists', response.data);
    return { success: false, lists: [] };
  }
};

export const fetchGZLists = async (orgId, userId) => {
  try {
    const { data } = await axios.get(
      `${heliosEndpoint}/gz/lists?orgId=${orgId}&userId=${userId}`
    );
    return { success: true, lists: data };
  } catch ({ response }) {
    console.error('Error retrieving GZ lists', response.data);
    return { success: false, lists: [] };
  }
};

export const fetchMagicLists = async (orgId, userId, category) => {
  try {
    let apiPath = `${heliosEndpoint}/magic/lists?orgId=${orgId}&userId=${userId}`;
    if (category) apiPath += `&category=${encodeURIComponent(category)}`;
    const { data } = await axios.get(apiPath);
    return { success: true, lists: data };
  } catch ({ response }) {
    console.error('Error retrieving Magic lists', response.data);
    return { success: false, lists: [] };
  }
};
